module.exports = __webpack_public_path__ + "img/logo-cctv.fcc3d3f1.png";